import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminGet } from "@/lib/adminApi";
import { PILLAR_LABELS } from "@/lib/instant";
import WeekGrid from "@/components/admin/WeekGrid";
import ClientFiche from "@/components/admin/ClientFiche";

export default function Dashboard({ goTo }) {
  const [d, setD] = useState(null);
  const [fiche, setFiche] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    adminGet("/dashboard").then(setD).catch(() => {});
  }, []);

  const openBooking = (booking) => {
    if (booking.user_id) {
      navigate(`/admin/patientele/${booking.user_id}`);
    } else {
      setFiche({ booking });
    }
  };

  if (!d) return <p className="rav-page-sub">Votre journée se prépare…</p>;

  const cards = [
    { label: "Comptes", value: d.users_count },
    { label: "Instants aujourd'hui", value: d.instants_today },
    { label: "Instants créés", value: d.instants_total },
    { label: "Instants terminés", value: d.instants_done },
    { label: "Demandes à traiter", value: d.requests_new, alert: d.requests_new > 0 },
    { label: "Rendez-vous confirmés", value: d.rdv_upcoming },
    { label: "Contenus actifs", value: d.contents_total },
  ];

  const totalFeelings = d.feelings_after.reduce((s, f) => s + f.count, 0) || 1;

  return (
    <div data-testid="admin-dashboard-module">
      <h2 className="rav-admin-h2">Aujourd'hui</h2>
      <div className="rav-admin-grid">
        {cards.map((c) => (
          <div key={c.label} className={`rav-stat-card${c.alert ? " is-alert" : ""}`} data-testid={`stat-${c.label}`}>
            <span className="rav-stat-value">{c.value}</span>
            <span className="rav-stat-label">{c.label}</span>
          </div>
        ))}
      </div>

      <h2 className="rav-admin-h2">Comment va votre communauté ?</h2>
      {d.feelings_after.length === 0 ? (
        <p className="rav-page-sub">Les ressentis après Instant apparaîtront ici.</p>
      ) : (
        <div className="rav-admin-list">
          {d.feelings_after.map((f) => (
            <div key={f._id} className="rav-bar-row">
              <span className="rav-bar-label">{f._id}</span>
              <span className="rav-bar-track">
                <span className="rav-bar-fill" style={{ width: `${Math.round((f.count / totalFeelings) * 100)}%` }} />
              </span>
              <span className="rav-bar-value">{Math.round((f.count / totalFeelings) * 100)} %</span>
            </div>
          ))}
        </div>
      )}

      <h2 className="rav-admin-h2">Piliers les plus proposés</h2>
      <div className="rav-admin-list">
        {d.pillars_top.map((p) => (
          <div key={p._id} className="rav-bar-row">
            <span className="rav-bar-label">{PILLAR_LABELS[p._id] || p._id}</span>
            <span className="rav-bar-track">
              <span className="rav-bar-fill" style={{ width: `${Math.min(100, p.count * 20)}%` }} />
            </span>
            <span className="rav-bar-value">{p.count}</span>
          </div>
        ))}
      </div>

      <h2 className="rav-admin-h2">Planning visio de Julie</h2>
      <WeekGrid onSelectBooking={openBooking} />
      {fiche && <ClientFiche detail={fiche.detail} booking={fiche.booking} onClose={() => setFiche(null)} />}
      <div className="rav-admin-list" data-testid="dashboard-planning">
        {(d.planning_next || []).length === 0 ? (
          <p className="rav-page-sub">Aucun rendez-vous à venir — ouvrez vos disponibilités dans la section Rendez-vous.</p>
        ) : (
          d.planning_next.map((r, i) => (
            <div key={r.id || i} className="rav-admin-row" data-testid={`dashboard-planning-row-${i}`}>
              <span className="rav-admin-row-label">
                {r.slot_label}
                {r.price != null ? ` — ${r.price} €` : ""}
              </span>
              <span className="rav-admin-row-sub">{[r.name, r.email, r.status].filter(Boolean).join(" · ")}</span>
            </div>
          ))
        )}
        <button type="button" className="rav-admin-row rav-admin-row-btn" data-testid="todo-planning" onClick={() => goTo("rdv")}>
          <span className="rav-admin-row-label">{d.planning_windows || 0} plage(s) de disponibilité ouverte(s)</span>
          <span className="rav-admin-row-sub">Gérer le planning de Julie</span>
        </button>
      </div>

      <h2 className="rav-admin-h2">À faire</h2>
      <div className="rav-admin-list">
        <button type="button" className="rav-admin-row rav-admin-row-btn" data-testid="todo-demandes" onClick={() => goTo("echanges")}>
          <span className="rav-admin-row-label">{d.requests_new} demande(s) à traiter</span>
          <span className="rav-admin-row-sub">Ouvrir les échanges</span>
        </button>
        <button type="button" className="rav-admin-row rav-admin-row-btn" data-testid="todo-rdv" onClick={() => goTo("rdv")}>
          <span className="rav-admin-row-label">{d.rdv_upcoming} rendez-vous confirmé(s)</span>
          <span className="rav-admin-row-sub">Voir les rendez-vous</span>
        </button>
      </div>
    </div>
  );
}
